export default {
  heading:
    'Thank you for considering Riverflex to support you on this opportunity.',
  body:
    'Selecting this option means we will contact you directly to discuss how Riverflex can best support progressing this opportunity.<br><br>We normally support in one of two ways:<br>1) Riverflex works with you as the opportunity owner to qualify and convert the opportunity to a role and then to staff a consultant onto the role on a shared revenue basis.<br>2) Or, Riverflex takes on the opportunity and when we staff a consultant onto the project we pay you a reward for bringing the opportunity to Riverflex.',
  termsField:
    'I understand that I am providing this opportunity to Riverflex and agree to the terms & conditions above.'
}
